import React, { Component } from 'react';
import { formConsumer } from 'core/form';
import { dateTimeFormatter } from 'core/util/dateUtils';
import AdminTable from 'app/components/admin/AdminTable';
import { Button, Flex } from 'core/components';
import { CELL_ACTIONS, CELL_TYPES, NewButton } from 'core/components/table';
import { FiEdit } from 'react-icons/fi';
import { withRouter } from 'react-router-dom';
import CompanyMessagesFormDialog from 'app/views/admin/messages/CompanyMessagesFormDialog';

@withRouter
@formConsumer
export default class CompanyMessages extends Component {
  state = { message: undefined };

  onNewMessageClick = () => {
    const { form } = this.props;
    this.handleEditMessage(form.model.get('messages').forge({ company_id: form.model.get('id') }));
  };

  handleEditMessage = (message) => {
    this.setState({ message });
  };

  onEditDialogClose = () => {
    this.setState({ message: undefined });
  };

  getColumns = () => [
    {
      label: 'Expires',
      name: 'expdate',
      renderer: dateTimeFormatter
    },

    {
      label: 'Message',
      name: 'message',
      flexBasis: 300
    },
    {
      label: 'Created',
      name: 'cdate',
      renderer: dateTimeFormatter
    },
    {
      type: CELL_TYPES.ACTION,
      actions: [
        (model) => <Button key="edit" onClick={() => this.handleEditMessage(model)} icon={FiEdit} minimal small />,
        CELL_ACTIONS.REMOVE
      ]
    }
  ];

  render() {
    const { form } = this.props;
    const { message } = this.state;
    return (
      <Flex flexDirection="column" flex={1} overflow="auto">
        <AdminTable
          collection={form.model.get('messages')}
          columns={this.getColumns()}
          containerProps={{ overflow: 'auto' }}
          tableContainerProps={{ overflow: 'auto' }}
          fetchCollectionOnMount={false}
          tableHeaderControlsPosition="afterSearch"
          tableHeaderControls={<NewButton ml={2} entityName="Banner" showIcon onClick={this.onNewMessageClick} />}
          flexed
        />
        {message && <CompanyMessagesFormDialog model={message} company={form.model} onClose={this.onEditDialogClose} />}
      </Flex>
    );
  }
}
